import Image from '@/components/UI/Image';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
const { EFPic } = createEFPic('/media/dg200/');

export default function IndexPc() {
    const { isMobile, useLang, useRouter } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['cn', 'fr', 'de', 'cis']);

    return (
        <div className="box">
            <div className="topBox">
                <div className="left boxItem">
                    <EFPic
                        name={[`${isMobile ? 'h5/' : 'pc/'}2-1.webp`, `${isMobile ? 'h5/' : 'pc/'}2-1.png`]}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('dg200.imgTextB_1')}
                    />
                    <div className="textBox">
                        <p className="text">
                            {t.rich('dg200.imgTextB_1', {
                                line1: (text: any) => <span className="extraBold">{text}</span>,
                                line2: (text: any) => <span className="orange">{text}</span>,
                            })}
                        </p>
                    </div>
                </div>
                <div className="middle boxItem">
                    <EFPic
                        name={[`${isMobile ? 'h5/' : 'pc/'}2-2.webp`, `${isMobile ? 'h5/' : 'pc/'}2-2.png`]}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('dg200.imgTextB_2')}
                    />
                    <div className="textBox">
                        <p className="text">
                            {t.rich('dg200.imgTextB_2', {
                                line1: (text: any) => <span className="sma">{text}</span>,
                                line2: (text: any) => <span className="lightBlue">{text}</span>,
                            })}
                        </p>
                    </div>
                </div>
                <div className="right boxItem">
                    <EFPic
                        name={[`${isMobile ? 'h5/' : 'pc/'}2-3.webp`, `${isMobile ? 'h5/' : 'pc/'}2-3.png`]}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('dg200.imgTextB_3')}
                    />
                    <div className="textBox">
                        <p className="text">
                            {t.rich('dg200.imgTextB_3', {
                                line1: (text: any) => <span className="orange">{text}</span>,
                                line2: (text: any) => <span className="line2">{text}</span>,
                            })}
                        </p>
                    </div>
                </div>
            </div>
            <div className="bottomBox">
                <div className="left boxItem">
                    <EFPic
                        name={[`${isMobile ? 'h5/' : 'pc/'}2-4.webp`, `${isMobile ? 'h5/' : 'pc/'}2-4.png`]}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('dg200.imgTextB_4')}
                    />
                    <div className="textBox">
                        <p className="text">{t('dg200.imgTextB_4')}</p>
                    </div>
                </div>
                <div className="middle boxItem">
                    <div className="img">
                        <Image
                            src={`/media/dg200/${isMobile ? 'h5/' : 'pc/'}2-5_${imgLocal}.svg`}
                            layout="fill"
                            className="fullImgs"
                            alt={t('dg200.imgTextB_5')}
                        />
                    </div>
                </div>
                <div className="right">
                    <div className="right_l boxItem">
                        <EFPic
                            name={[`${isMobile ? 'h5/' : 'pc/'}2-6.webp`, `${isMobile ? 'h5/' : 'pc/'}2-6.png`]}
                            // layout="fill"
                            className="fullImgs"
                            alt={t('dg200.imgTextB_6')}
                        />
                        <div className="textBox">
                            <p className="text">{t('dg200.imgTextB_6')}</p>
                        </div>
                    </div>
                    <div className="right_r boxItem">
                        <EFPic
                            name={[`${isMobile ? 'h5/' : 'pc/'}2-7.webp`, `${isMobile ? 'h5/' : 'pc/'}2-7.png`]}
                            // layout="fill"
                            className="fullImgs"
                            alt={t('dg200.imgTextB_7')}
                        />
                        <div className="textBox">
                            <p className="text">
                                {t.rich('dg200.imgTextB_7', {
                                    line: (text: any) => <span className="line">{text}</span>,
                                })}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
